<mat-card class="mat-elevation-z8">
    <form [formGroup]="employee_register_form">
        <!-- user details -->
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>First name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='first_name'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Last name <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="text" class="form-control code_box" formControlName='last_name'>
                </div>
            </div>

        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Union <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='union_id'>
                        <option *ngFor="let union of unions" [value]="union['id']">{{union['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Gender <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='gender_id'>
                        <option *ngFor="let gender of genders" [value]="gender['id']">{{gender['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="col">
                    <div class="form-group">
                        <label>Street Address</label>
                        <input type="text" class="form-control code_box" formControlName='street'>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Taluk <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='taluk_id'>
                        <option *ngFor="let taluk of taluks" [value]="taluk['id']">{{taluk['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">District <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='district_id'>
                        <option *ngFor="let district of districts" [value]="district['id']">{{district['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">State <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='state_id'>
                        <option *ngFor="let state of states" [value]="state['id']">{{state['name']}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Pincode</label>
                    <input type="number" class="form-control code_box" formControlName='pincode'>
                    <div style="font-style: italic; font-size: small"
                        [ngStyle]="{'color': employee_register_form.controls.pincode.valid? 'green': 'red'}"
                        *ngIf="employee_register_form.controls.pincode.errors !== null">
                        {{ employee_register_form.controls.pincode.errors['error']}}
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Mobile <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="number" class="form-control code_box" formControlName='mobile' onkeydown="javascript: return event.keyCode == 69 ? false : true">
                    <div style="font-style: italic; font-size: small; color:red"
                        *ngIf="employee_register_form.controls.mobile.errors !== null">
                        {{ employee_register_form.controls.mobile.errors['error']}}
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Alternative mobile</label>
                    <input type="number" class="form-control code_box" formControlName='alternate_mobile' onkeydown="javascript: return event.keyCode == 69 ? false : true">
                    <div style="font-style: italic; font-size: small; color:red"
                        *ngIf="employee_register_form.controls.alternate_mobile.errors !== null">
                        {{ employee_register_form.controls.alternate_mobile.errors['error']}}
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Office <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='office'>
                        <option *ngFor="let office of offices" [value]="office['id']">{{office['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlSelect1">Role <i class="material-icons"
                            style="color: red;font-size: 14px;">star</i></label>
                    <select class="form-control dropdown_box" formControlName='role'>
                        <option *ngFor="let role of roles" [value]="role['id']">{{role['name']}}
                        </option>
                    </select>
                </div>
            </div>
            <!-- <div class="col">
                <div class="form-group">
                    <label>Joining Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="date" class="form-control" formControlName='joining_date'>
                </div>
            </div> -->
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Joining Date <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
                    <input type="date" class="form-control code_box" formControlName='joining_date'>
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>Release Date</label>
                    <input type="date" class="form-control code_box" formControlName='release_date'>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label for="exampleFormControlFile1">Employee Image</label>
                    <input type="file" class="form-control-file" id="exampleFormControlFile1"
                        (change)="toBase64($event)" accept="image/*" formControlName='employee_image'>
                </div>
            </div>
            <div class="col" *ngIf="image != null">
                <img [src]="image" style="height: 100px;">
            </div>
        </div>
        <button style="margin-left: 40%;" mat-raised-button color="primary" [disabled]="!employee_register_form.valid"
            (click)="registerEmployee()">{{action}}</button>
            <mat-icon *ngIf="register_on_process">
                <mat-spinner  [color]="color" diameter="30"  [value]="value" style="margin-top: 3px;margin-left: 12px;" >
                </mat-spinner>
              </mat-icon>
    </form>
</mat-card>
